<template>
    <div>
        <skeleton-loader v-if="pending" :skeleton="props.skeleton"/>
        <lazy-alert v-else-if="error" text type="error">{{ error }}</lazy-alert>
        <lazy-user-content v-else-if="content" :center="center" :text="content"/>
        <lazy-missing-info v-else-if="props.missing" :text="props.missing" large/>
    </div>
</template>

<script setup lang="ts">
import {computed} from 'vue';
import {useApiFetch} from '#imports';
import type {HttpMethod} from "../../types/http";

const props = withDefaults(defineProps<{
	// The url where to send the request
	action: string,

	// The server response prop to access the required value
	access?: string,

	// The skeleton type to show when the content is loading
	skeleton?: string,

	// The method to use for the request
	method?: HttpMethod,

	// The text to display when no value exists
	missing?: string,

	// The data to send to the server when retrieving the content
	data?: object,

	// Whether to center the content
	center?: boolean,

	// Whether to send the request as guest for performance improvements
	asGuest?: boolean
}>(), {
	access: null,
	skeleton: 'paragraph@10',
	method: 'GET',
	missing: null,
	data: {},
	center: false
});

const {reactiveData: fullContent, pending, error} = await useApiFetch(props.action, {
	guest: props.asGuest,
	method: props.method,
	data: props.data,
	lazy: true
});
const content = computed(() => {
	return props.access && fullContent.value ? fullContent.value[props.access] : fullContent.value;
});
</script>